import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Removed TypeScript interfaces

const initialState = {
  follows: [],
  loading: false,
  error: null,
};

export const fetchFollows = createAsyncThunk('follow/fetchFollows', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/follow/followed');
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const followRepresentative = createAsyncThunk(
  'follow/followRepresentative',
  async (representativeId, { rejectWithValue }) => {
    try {
      const response = await api.post('/follow/follow', { representativeId });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const unfollowRepresentative = createAsyncThunk(
  'follow/unfollowRepresentative',
  async (representativeId, { rejectWithValue }) => {
    try {
      const response = await api.post('/follow/unfollow', { representativeId });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const followSlice = createSlice({
  name: 'follow',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFollows.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFollows.fulfilled, (state, action) => {
        state.loading = false;
        state.follows = action.payload;
      })
      .addCase(fetchFollows.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(followRepresentative.fulfilled, (state, action) => {
        state.follows.push(action.payload);
      })
      .addCase(unfollowRepresentative.fulfilled, (state, action) => {
        state.follows = state.follows.filter(
          (follow) => follow.representativeId !== action.meta.arg
        );
      });
  },
});

export default followSlice.reducer;
